import { useState } from 'react';

import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

import ReportCreateModal from './index';

interface ReportCreateTriggerProps {
  patientId: string;
  refetch: () => void;
}

const ReportCreateTrigger = ({ patientId, refetch }: ReportCreateTriggerProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => {
    refetch();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button size="xs" onClick={handleOpen} variant="subtle" leftSection={<IconPlus size={16} />}>
        Create Report
      </Button>

      <ReportCreateModal isOpen={isModalOpen} onClose={handleClose} patientId={patientId} />
    </>
  );
};

export default ReportCreateTrigger;
